import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ModalPricingService {

    constructor() { }

    private hiddenModal: boolean = true;

    public userSubscriber: EventEmitter<string> = new EventEmitter<string>();

    hidden(): boolean {
        return this.hiddenModal;
    }

    showModal() {
        this.hiddenModal = false;
    }

    hideModal() {
        this.hiddenModal = true;
    }
}
